import { render } from "./CopyLayers.vue?vue&type=template&id=dc55e3bc"
import script from "./CopyLayers.vue?vue&type=script&lang=js"
export * from "./CopyLayers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__